module.exports = __webpack_public_path__ + "static/blog-img6-c4849c23f0f96fb9db3bb5a803625efa.jpg";